import { Directive, Input, HostListener, Renderer2, ElementRef, OnDestroy } from '@angular/core';

@Directive({
  selector: '[appTooltip]',
  standalone: true,
})
export class TooltipDirective implements OnDestroy {
  @Input('appTooltip') tooltipText: string = '';

  private tooltipEl: HTMLElement | null = null;
  private readonly offset = 10;

  constructor(private renderer: Renderer2, private el: ElementRef) {}

  @HostListener('mouseenter', ['$event'])
  onMouseEnter(e: MouseEvent) {
    if (!this.tooltipText) return;
    this.create();
    this.position(e.clientX, e.clientY);
  }

  @HostListener('mousemove', ['$event'])
  onMouseMove(e: MouseEvent) {
    if (this.tooltipEl) {
      this.position(e.clientX, e.clientY);
    }
  }

  @HostListener('mouseleave')
  onMouseLeave() {
    this.destroy();
  }

  private create() {
    if (this.tooltipEl) return;

    this.tooltipEl = this.renderer.createElement('div');
    this.renderer.setProperty(this.tooltipEl, 'textContent', this.tooltipText);

    const styles: Record<string, string> = {
      position: 'fixed',
      'z-index': '99999',
      'max-width': '300px',
      padding: '8px 12px',
      'font-size': '12px',
      'line-height': '1.4',
      color: '#fff',
      background: '#1f2937',
      'border-radius': '8px',
      'box-shadow': '0 4px 12px rgba(0,0,0,0.3)',
      'pointer-events': 'none',
      'white-space': 'pre-wrap',
      'word-wrap': 'break-word',
    };

    Object.entries(styles).forEach(([key, value]) => {
      this.renderer.setStyle(this.tooltipEl, key, value);
    });

    this.renderer.appendChild(document.body, this.tooltipEl);
  }

  private position(mx: number, my: number) {
    if (!this.tooltipEl) return;

    const vw = window.innerWidth;
    const vh = window.innerHeight;
    const rect = this.tooltipEl.getBoundingClientRect();
    const tw = rect.width;
    const th = rect.height;

    // Default: right-bottom of cursor
    let left = mx + this.offset;
    let top = my + this.offset;

    // Flip left if overflows right
    if (left + tw > vw - 8) {
      left = mx - tw - this.offset;
    }

    // Flip up if overflows bottom
    if (top + th > vh - 8) {
      top = my - th - this.offset;
    }

    this.renderer.setStyle(this.tooltipEl, 'left', `${left}px`);
    this.renderer.setStyle(this.tooltipEl, 'top', `${top}px`);
  }

  private destroy() {
    if (this.tooltipEl) {
      this.renderer.removeChild(document.body, this.tooltipEl);
      this.tooltipEl = null;
    }
  }

  ngOnDestroy() {
    this.destroy();
  }
}
